import type { Context } from '../types';

export const context: Context = {
  analytics: { currentPage: '' },
  helpers: {
    checkForTokens: async () => false,
    getToken: async () => null,
    setSignupMethod: () => {},
    updateConsent: () => {},
  },
  isLoading: false,
  OAuth: {
    errors: [],
    method: 'manual',
    platform: 'Google',
    source: 'signup',
    windowWidth: 520,
  },
  standardAuth: {
    account: { acceptsEmail: false, email: '', firstName: '', password: '', lastName: '' },
    errors: [],
    reCaptcha: { ref: undefined },
  },
  user: { createdAt: undefined, isLoggedIn: false },
};
